<template>
  <div style="height: calc(100vh - 70px)">
    <el-row>
      <el-col :span="24">
        <div class="grid-content" style="padding-top: 20px">
          <img class="common-img-icon" :src="apfConfig[group].schoolIcon" style="width: 30%; display: block; margin: 0 auto" />
          <img src="../../../assets/tick.png" style="width: 100px" />
          <h3 class="success-text">
            Thank you for your draft submission. You will receive an email notification shortly with the link for your draft submission.
          </h3>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apfConfig from '@/pages/application/config/apfConfig'

export default {
  props: ['group'],
  data() {
    return {
      apfConfig,
    }
  },
}
</script>
